<div class="mt-2">

  <!-- FEED TABS -->
  <mat-tab-group animationDuration="0ms"
                 (selectedTabChange)="selectedTabChange($event)">
    <mat-tab label="Attack"></mat-tab>
    <mat-tab label="Spam"></mat-tab>
    <mat-tab label="GeoIP"></mat-tab>
    <mat-tab label="DNS Watch"></mat-tab>
  </mat-tab-group>

  <!-- RANGE TABS -->
  <mat-tab-group animationDuration="0ms"
                 class="mt-2"
                 (selectedTabChange)="selectedTabChange($event)">
    <mat-tab label="Last 4 Hrs"></mat-tab>
    <mat-tab label="Last 24 Hrs"></mat-tab>
    <mat-tab label="Last 7 Days"></mat-tab>
    <mat-tab label="This Month"></mat-tab>
    <mat-tab label="Last Month"></mat-tab>
  </mat-tab-group>

  <!-- TABLE -->
  <div class="mt-3 position-relative">

    <table mat-table
           [dataSource]="_dataSource"
           matSort
           class="mat-elevation-z8 w-100">

      <!-- Timestamp -->
      <ng-container matColumnDef="Timestamp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Timestamp
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.timestamp }}
        </td>
      </ng-container>

      <!-- State -->
     <ng-container matColumnDef="State">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
        <td mat-cell *matCellDef="let row">
         <span class="badge" [ngClass]="getStateClass(row.state)">
            {{ row.state }}
          </span>

        </td>
      </ng-container>

     <!-- Items -->
    <ng-container matColumnDef="Items">
      <th mat-header-cell *matHeaderCellDef>Items</th>
      <td mat-cell *matCellDef="let row">

        <ng-container *ngIf="row.items?.length; else noItems">

          <span class="items-inline">
            <ng-container
              *ngFor="let item of getTopItems(row.items, 10); let last = last">
              {{ item[0] }}({{ item[1] }})<span *ngIf="!last">, </span>
            </ng-container>
          </span>

          <!-- See more -->
          <button
            *ngIf="row.items.length > 10"
            mat-button
            color="primary"
            class="see-more"
            (click)="openItemsModal(row.items)">
            {{row.items.length}}+ more
          </button>

        </ng-container>

        <ng-template #noItems>-</ng-template>

      </td>
    </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <!-- PAGINATOR -->
    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="handlePageEvent($event)">
    </mat-paginator>

  </div>
</div>
